import {createContext} from "preact/compat";

export const FlowNavTopContext = createContext(0);
export const FlowNavSideContext = createContext({});